import { createRouter, createWebHistory } from 'vue-router'
import ChatViewMobile from '@/views/ChatViewMobile.vue'
import Main from "@/views/Main.vue";


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main
    },
    {
      path: '/mobile',
      name: 'chatMobile',
      component: ChatViewMobile
    },
  ]
})

export default router